import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class NewAuditService {
  apiUrl = this.environment.baseUrl;

  companyUpdated = new BehaviorSubject<any>(null);
  companyObs = this.companyUpdated.asObservable();

  auditUpdated = new BehaviorSubject<any>(null);
  auditsObs = this.auditUpdated.asObservable();

  locationUpdated = new BehaviorSubject<any>(null);
  locationObs = this.locationUpdated.asObservable();

  auditCreated = new BehaviorSubject<boolean>(false);
  auditEdited = new BehaviorSubject<boolean>(false);
  questionAnswered = new BehaviorSubject<boolean>(false);

  imgUpdated = new BehaviorSubject<any>([]);
  imgObs = this.imgUpdated.asObservable();

  imageLengthUpdated = new BehaviorSubject<any>(null);
  imgLengthObs = this.imageLengthUpdated.asObservable();

  callOpenQuesAPI = new BehaviorSubject<any>(null);

  appOpenUpdated = new BehaviorSubject<any>(false);
  appOpenObs = this.appOpenUpdated.asObservable();

  appClosedUpdated = new BehaviorSubject<any>(false);
  appClosedObs = this.appClosedUpdated.asObservable();

  isIncident = new BehaviorSubject(false);

  // Track if we're in open-section context (for child question auto-loading)
  isOpenSectionContext = new BehaviorSubject<boolean>(false);

  fileUpdated = new BehaviorSubject<any>([]);
  fileObs = this.fileUpdated.asObservable();

  fileLengthUpdated = new BehaviorSubject<any>(null);
  fileLengthObs = this.fileLengthUpdated.asObservable();

  constructor(private http: HttpClient, public environment: EnvService) { }

  imageLengthUpdate(image: any) {
    // console.log('img service >>>', image);
    this.imageLengthUpdated.next(image);
  }

  updateFileLength(file: any) {
    // console.log('img service >>>', image);
    this.fileLengthUpdated.next(file);
  }

  companyUpdate(company: any) {
    // console.log(company);
    this.companyUpdated.next(company);
  }

  auditUpdate(audit: any) {
    // console.log(audit);
    this.auditUpdated.next(audit);
  }

  locationUpdate(loc: any) {
    // console.log(loc);
    this.locationUpdated.next(loc);
  }

  imageUpdate(img) {
    // console.log(img);
    this.imgUpdated.next([...this.imgUpdated.value, img]);
  }

  appOpenUpdate(value) {
    localStorage.setItem('openAppClicked', value);
    this.appOpenUpdated.next(value);
  }

  appClosedUpdate(value) {
    this.appClosedUpdated.next(value);
  }

  getCompaniesList(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/company/list`, params);
  }
  // getCompaniesList(params: any) {
  //   return this.http.post<any>(`${this.apiUrl}audits/company/list`, params);
  // }
  getAuditsList(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/auditname/list`, params);
  }

  getLocationsList(params: any, manualLoader: boolean = false) {
    if (manualLoader) {
      // Bypass interceptor's automatic loader management
      return this.http.post<any>(`${this.apiUrl}audits/location/list`, params, { headers: { hideLoader: 'true' } });
    }
    return this.http.post<any>(`${this.apiUrl}audits/location/list`, params);
  }

  getPersonSeenInfo(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/personseen/list`, params);
  }

  getCustomFieldsList(params: any, manualLoader: boolean = false) {
    if (manualLoader) {
      return this.http.post<any>(`${this.apiUrl}audits/customfield/list`, params, { headers: { hideLoader: 'true' } });
    }
    return this.http.post<any>(`${this.apiUrl}audits/customfield/list`, params);
  }

  createAudit(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/create/audit`, params);
  }

  // sectionlist from the API
  getAllSections(request) {
    return this.http.post<any>(`${this.apiUrl}audits/section/list`, request);
  }
  // Get groups with questions from the API
  getGroupQuestions(request) {
    return this.http.post<any>(`${this.apiUrl}audits/question/list`, request);
  }

  //save question answer

  saveQuestionAnswer(request) {
    // const headers = new HttpHeaders({
    //   hideLoader: 'true',
    // });

    return this.http.post<any>(`${this.apiUrl}audits/question/save`, request, { headers: { hideLoader: 'true' } });
  }

  //get actions data
  getActionDetails(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/get/action`, request, { headers: { hideLoader: 'true' } });
  }

  saveActionDetails(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/action/save`, request, { headers: { hideLoader: 'true' } });
  }

  setAuditCreated(hasValue) {
    this.auditCreated.next(hasValue);
  }

  getAuditCreated(): Observable<boolean> {
    return this.auditCreated.asObservable();
  }

  //get signatures
  getCommentSign(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/getcommentsign`, request);
  }

  saveCommentSign(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/savecommentsign`, request);
  }
  saveSignature(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/saveSignature`, request);
  }

  //get cloud key
  getCloudKey(request: any, headers?: any) {
    return this.http.post<any>(`${this.apiUrl}audits/get/cloudkey`, request, headers);
  }
  //save image
  saveImageUrl(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/savephotourl`, request, { headers: { hideLoader: 'true' } });
  }

  // get preview open count
  getPreviewOpenCount(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/preview/open`, request);
  }

  //save group comments
  saveGroupComments(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/save/section/comment`, request, { headers: { hideLoader: 'true' } });
  }
  //delete photo
  deletePhoto(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/delete/photo`, request, { headers: { hideLoader: 'true' } });
  }

  // download report
  downloadReport(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/report/getpdf`, request);
  }

  // Get email list for preview page
  getEmailList(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/email/list`, request);
  }

  // Get open question for preview page
  getOpenQues(request: any) {
    // return this.http.post<any>(`${this.apiUrl}audits/question/open/list`, request);
    return this.http.post<any>(`${this.apiUrl}audits/question/open/parent/list`, request);
  }

  // Get child questions for parent questions
  getChildQuestions(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/question/child/list`, request);
  }

  setCallOpenQuesAPI(mandatory) {
    this.callOpenQuesAPI.next(mandatory);
  }

  getCallOpenQuesAPI(): Observable<any> {
    return this.callOpenQuesAPI.asObservable();
  }

  // Get choice list preview page
  getChoiceList(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/preview/choice/list`, request);
  }

  // Mark completed preview page
  markCompleted(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/mark/complete`, request);
  }

  setAuditEdited(hasValue) {
    this.auditEdited.next(hasValue);
  }

  getAuditEdited(): Observable<boolean> {
    return this.auditEdited.asObservable();
  }

  updateAudit(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/update/audit`, params);
  }

  companyLogo(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/company/logo`, params);
  }

  auditLogo(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/auditname/logo`, params);
  }

  setQuestionAnswered(hasValue) {
    this.questionAnswered.next(hasValue);
  }

  getQuestionAnswered(): Observable<boolean> {
    return this.questionAnswered.asObservable();
  }

  addNewLocation(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/location/create`, params);
  }

  getCustomEmailFlag(params) {
    return this.http.post<any>(`${this.apiUrl}audits/get/customemailflag`,params);
  }

  getSectionComments(params: any) {
    return this.http.post<any>(`${this.apiUrl}audits/get/sectioncommts`, params, { headers: { hideLoader: 'true' } });
  }

  // sectionlist from the API
  getAuditIDParams(request) {
    return this.http.post<any>(`${this.apiUrl}audits/auditid/params`, request);
  }

  setIncidentFlag(value) {
    this.isIncident.next(value);
  }

  setOpenSectionContext(value: boolean) {
    this.isOpenSectionContext.next(value);
  }

  getOpenSectionContext(): Observable<boolean> {
    return this.isOpenSectionContext.asObservable();
  }

  getChecklistDetails(params: any, manualLoader: boolean = false) {
    if (manualLoader) {
      return this.http.post<any>(`${this.apiUrl}audits/checklist/details`, params, { headers: { hideLoader: 'true' } });
    }
    return this.http.post<any>(`${this.apiUrl}audits/checklist/details`, params);
  }
  confidentialText(){
    const options: object = {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain; charset=utf-8'
      }),
      responseType: 'text'
  };
    const det = JSON.parse(localStorage.getItem("signedDetails"))
    return this.http.get<any>(`${this.apiUrl}audits/confidential/message?guid=${det.guid}&uid=${det.uid}&client_id=${det.client_id}&audit_type_id=${det.audit_type_id}`, options)
  };
  
  deleteSignature(params){
    return this.http.post<any>(`${this.apiUrl}audits/deleteSignature`, params);
  }

  getAccountFlags(guid) {
    return this.http.get<any>(`${this.environment.adminUrl}user/api/user/getAccountFlags/` + guid);
  }

  // save File
  saveFile(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/save/file`, request, { headers: { hideLoader: 'true' } });
  }

  //delete File
  deleteFile(request: any) {
    return this.http.post<any>(`${this.apiUrl}audits/delete/file`, request, { headers: { hideLoader: 'true' } });
  }

  updateFile(file) {
    this.fileUpdated.next([...this.fileUpdated.value, file]);
  }

  transformImage(request,width) {
    const headers = new HttpHeaders({
      hideLoader: 'true'
    });
    return this.http.get<any>(`${this.apiUrl}audits/get/transform?url=`+request+"&width="+width, { headers: headers });
  }

  /**
   * Check if children have been fetched for a choice list
   * @param choiceList - The choice list object to check
   * @returns true if children have been fetched or no choices exist
   */
  areChildrenFetched(choiceList: any): boolean {
    if (!choiceList.choiceList || choiceList.choiceList.length === 0) {
      return true;
    }
    const firstChoice = choiceList.choiceList[0];
    return firstChoice && firstChoice.childrenFetched === true;
  }

  /**
   * Load child questions for a parent question and update the choiceList
   * @param choiceList - The choice list object containing question information
   * @param user - The user object from localStorage
   * @param audit - The audit object from localStorage
   * @param language - The current language setting
   */
  loadChildQuestionsForChoice(choiceList: any, user: any, audit: any, language: string = 'en'): void {
    const mandatory = JSON.parse(localStorage.getItem('open_questions'));
    
    const requestBody: any = {
      uid: user.auditor_uid,
      guid: user.guid,
      client_id: audit[0].client_id,
      audit_type_id: audit[0].audit_type_id,
      audit_date: audit[0].audit_date,
      store_id: audit[0].store_id,
      seq_no: audit[0].seq_no,
      open_questions: mandatory ? mandatory.open_questions : 0,
      question_mandatory: mandatory ? mandatory.question_mandatory : 0,
      image_mandatory: mandatory ? mandatory.image_mandatory : 0,
      comment_mandatory: mandatory ? mandatory.comment_mandatory : 0,
      action_mandatory: mandatory ? mandatory.action_mandatory : 0,
      file_mandatory: mandatory ? mandatory.file_mandatory : 0,
      choice_text: mandatory ? mandatory.choice_text : "",
      pLang: language === 'en' ? '' : language,
      question_no: choiceList.question_no,
      file_count: mandatory ? mandatory?.file_count : ''
    };

    this.getChildQuestions(requestBody).subscribe(
      (res) => {
        if (res && res[0] && res[0].groupList && res[0].groupList[0]) {
          const allQuestions = res[0].groupList[0].questionList || [];
          
          choiceList.choiceList.forEach(choice => {
            const childrenForThisChoice = allQuestions.filter(q => q.parent_choice_id === choice.choice_id);
            
            if (!choice.questionlist) {
              choice.questionlist = [];
            }
            
            const startIndex = choice.questionlist.length;
            childrenForThisChoice.forEach((child, index) => {
              child['headerToggle'] = true;
              child['ischoice_q'] = true;
              child['subQuestionNumber'] = startIndex + index + 1;
              child.showHelpAuto = child.auto_show ? child.auto_show : false;
            });
            
            choice.questionlist = [...choice.questionlist, ...childrenForThisChoice];
            choice.childrenFetched = true;
          });
        }
      },
      (error) => {
        console.log('Error loading child questions:', error);
      }
    );
  }

  downloadPdf(payload): any {
    return this.http.post(`${this.environment.adminUrl}reports/api/reports/open/blanktemplate`,payload)
  }

  getDownloadpdfFlag() {
    return this.http.get(`${this.environment.adminUrl}user/api/user/getblanktempalte`);
  }

  updateschedule(params: any) {
    return this.http.post<any>(`${this.environment.scheduleurl}updateAllStatus`, params);
  }

}
